import React from 'react'
import styled from 'styled-components'

type Props = {
  children: React.ReactNode
}

export const AuthWrapper = ({ children }: Props): JSX.Element => (
  <Wrapper>
    <Body>
      {children}
      <Footer className="footer">
        <Copyright>
          Simulated Aptitude Inc. © All Rights Reserved{' '}
          {new Date().getFullYear()}
        </Copyright>
        <Links>
          <PageLink
            href="https://yogi-app.s3.us-west-2.amazonaws.com/YogiTermsAndConditions.pdf"
            target="_blank"
          >
            Terms of Use
          </PageLink>
          <PageLink
            href="https://yogi-app.s3.us-west-2.amazonaws.com/YogiPrivacyPolicy.pdf"
            target="_blank"
          >
            Privacy Policy
          </PageLink>
          <PageLink
            href="https://www.microsoft.com/en-us/privacy/privacystatement"
            target="_blank"
          >
            Microsoft Privacy Statement
          </PageLink>
        </Links>
      </Footer>
    </Body>
  </Wrapper>
)

const headerHeight = 72

export const LogoBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 26px;

  height: ${headerHeight}px;
  max-width: 1440px;
  width: 100%;
`

export const Logo = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`

export const LogoImage = styled.img`
  height: 40px;
`

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  overflow: auto;
  font-size: 14px;

  background-color: #fff;
`

const Body = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 48px;
`

const Footer = styled.div`
  margin-top: 42px;
`

const Links = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin-top: 16px;

  a {
    position: relative;
    margin-left: 22px;
  }

  a::before {
    content: '';
    display: block;
    position: absolute;
    left: -13px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #acb5bd;
  }

  a:first-child {
    margin-left: 0;
  }

  a:first-child::before {
    display: none;
  }
`

const Copyright = styled.div`
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  color: #acb5bd;
`

const PageLink = styled.a`
  color: #acb5bd;
  text-decoration: underline;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`
